import { computed, ref } from 'vue';
import type { ComputedRef, Ref } from 'vue';

import { useI18n } from 'vue-i18n';

import type { SelectOption } from '@/components/common/types/selectOptionTypes';
import { useSubNetworksStore } from '@/stores/subNetworksStore';


type UseMapMainSubNetworkFilterResult = {
	options: ComputedRef<SelectOption[]>;
	selected: Ref<number>;
	baseStationsInSN: ComputedRef<number[]>;
};

export function useMapMainSubNetworkFilter(): UseMapMainSubNetworkFilterResult {
	const { t } = useI18n();
	const subNetworksStore = useSubNetworksStore();
	const selected = ref(0);
	const options = computed((): SelectOption[] => [
		{
			value: 0,
			label: t('home-map.subNetworkFilter.allSubnets'),
		},
		...subNetworksStore.subNetworkFilterOptions,
	]);
	const subNetworkSelectedId = computed({
		get: () => subNetworksStore.subNetworkSelectedId,
		set: value => {
			if (value != null) {
				subNetworksStore.updateSubNetworkSelectedId(value);
			}
		},
	});
	const baseStationsInSN = computed((): number[] => {
		const targetSubNetworkId = selected.value === 0 ? subNetworkSelectedId.value : selected.value;
		const subNetwork = subNetworksStore.getSubNetworkById(targetSubNetworkId);
		if (subNetwork === null) {
			// если пустой список, фильтры применяются, будет пусто
			return [];
		}
		return subNetwork.base_stations.map(item => item.id);
	});
	return {
		options,
		selected,
		baseStationsInSN,
	};
}
